const Alert = ({children, type = 'info'}) => {

    return (
        <div className={"alert-message alert-" + type}>
            {children}
        </div>
    );
}

export default Alert;